export enum MutationTypes {
    SET_SHORT_STATISTICS = 'statistics-module/set-short-statistics'
}
